module.exports = __webpack_public_path__ + "img/home-text.2cce3bb1.png";